import { Tooltip, Space, Button, Popconfirm, DatePicker, Input } from "antd";
import { EditOutlined, DeleteOutlined, PrinterOutlined, FileTextOutlined, EyeOutlined } from "@ant-design/icons";
import { FaTruckLoading } from "react-icons/fa";
import dayjs from "dayjs";

import { docLinkRender } from "../../../components/table/DocLink";
export const accessColumn = ({ handleView, handleEdit, handleDelete, handlePrint, handleCreatePackingList, handleCreateInvoice }) => [
  {
    title: "เลขที่ใบส่งมอบ",
    key: "delcode",
    dataIndex: "delcode",
    width: 150,
    align: "left",
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูใบส่งมอบ"),
  },
  {
    title: "Job Order",
    key: "jocode",
    dataIndex: "jocode",
    width: 100,
    align: "center",
  },
  {
    title: "โหลด",
    key: "load_no",
    dataIndex: "load_no",
    width: 70,
    align: "center",
    render: (v) => `โหลดที่ ${v}`,
  },
  {
    title: "ลูกค้า",
    key: "cusname",
    dataIndex: "cusname",
    width: 200,
  },
  {
    title: "Brand",
    key: "brand",
    dataIndex: "brand",
    width: 150,
  },
  {
    title: "วันที่ส่งมอบ",
    key: "dlvdate",
    dataIndex: "dlvdate",
    width: 120,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "จำนวน/กล่อง",
    key: "total_carton",
    dataIndex: "total_carton",
    width: 110,
    align: "right",
    render: (v) => Number(v || 0).toLocaleString(),
  },
  {
    title: "สร้างโดย",
    key: "created_name",
    dataIndex: "created_name",
    width: 150,
  },
  {
    title: "Action",
    key: "action",
    fixed: "right",
    width: 240,
    render: (_, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้่อมูล"
          style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => handleView(record)}
        />
        <Button
          size="small"
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => handleEdit(record)}
        />
        {/* <Tooltip title="สร้าง Invoice">
          <Button
            size="small"
            icon={<FileTextOutlined />}
            className="bn-success-outline"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={() => handleCreateInvoice(record)}
          />
        </Tooltip> */}
        <Button
          size="small"
          icon={<PrinterOutlined />}
          className="bn-warning-outline"
          style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => handlePrint(record)}
        />
        <Tooltip title="สร้าง Packing List">
          <Button
            size="small"
            icon={<FaTruckLoading />}
            className="bn-info-outline"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={() => handleCreatePackingList(record)}
          />
        </Tooltip>
        <Popconfirm
          title="ยืนยันการลบ?"
          onConfirm={() => handleDelete(record)}
          okText="ลบ"
          cancelText="ยกเลิก"
        >
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          />
        </Popconfirm>
      </Space>
    ),
  },
];

export const detailColumns = ({ updateDetail, deleteDetail, readOnly = false }) => [
  { title: "ลำดับ", key: "seq", dataIndex: "seq", width: 60, align: "center" },
  { title: "รหัสสินค้า", key: "pg_code", dataIndex: "pg_code" },
  { title: "รายการสินค้า", key: "pg_name", dataIndex: "pg_name" },
  {
    title: "วันที่ผลิต", key: "production_date", width: 165, align: "center",
    render: (_, record, index) => (
      <DatePicker
        value={record.production_date}
        disabled={readOnly}
        format="DD/MM/YYYY"
        style={{ width: "100%" }}
        onChange={(val) => updateDetail(index, "production_date", val)}
      />
    ),
  },
  {
    title: "วันที่หมดอายุ", key: "expiry_date", width: 165, align: "center",
    render: (_, record, index) => (
      <DatePicker
        value={record.expiry_date}
        disabled={readOnly}
        format="DD/MM/YYYY"
        style={{ width: "100%" }}
        onChange={(val) => updateDetail(index, "expiry_date", val)}
      />
    ),
  },
  {
    title: "จำนวน/กล่อง", key: "carton", width: 130, align: "right",
    render: (_, record, index) => (
      <Input
        value={record.carton}
        disabled={readOnly}
        style={{ textAlign: "right" }}
        onChange={(e) => updateDetail(index, "carton", e.target.value)}
      />
    ),
  },
  {
    /* ลูกค้าต้องการขึ้นบรรทัดใหม่ในหมายเหตุได้ (เช่น 01 = 17 กล่อง / 02 = 12 กล่อง) */
    title: "หมายเหตุ", key: "detail_remark", width: 200,
    render: (_, record, index) => (
      <Input.TextArea
        value={record.detail_remark}
        disabled={readOnly}
        autoSize={{ minRows: 1, maxRows: 6 }}
        onChange={(e) => updateDetail(index, "detail_remark", e.target.value)}
      />
    ),
  },
  ...(readOnly
    ? []
    : [
        {
          title: "", key: "action", width: 50, align: "center",
          render: (_, record) => (
            <Button
              type="text" danger size="small" icon={<DeleteOutlined />}
              onClick={() => deleteDetail(record.seq)}
            />
          ),
        },
      ]),
];

export const detailColumn = () => [
  {
    title: "ลำดับ",
    key: "seq",
    dataIndex: "seq",
    width: 60,
    align: "center",
  },
  {
    title: "รายการสินค้า",
    key: "pg_name",
    dataIndex: "pg_name",
  },
  {
    title: "วันที่ผลิต",
    key: "production_date",
    dataIndex: "production_date",
    width: 130,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "วันที่หมดอายุ",
    key: "expiry_date",
    dataIndex: "expiry_date",
    width: 130,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "จำนวน/กล่อง",
    key: "carton",
    dataIndex: "carton",
    width: 120,
    align: "right",
    render: (v) => Number(v || 0).toLocaleString(),
  },
  {
    title: "หมายเหตุ",
    key: "detail_remark",
    dataIndex: "detail_remark",
    width: 200,
    render: (v) => (
      <span style={{ whiteSpace: "pre-line" }}>{v || ""}</span>
    ),
  },
];
